import React from "react";
import { useTranslation } from 'react-i18next';



export default function HeadofficeMessage() {
    const { t } = useTranslation();
    return (
        <div className="container ho-message" style={{ marginTop: '50px' }}>
            <div className="row justify-content-center">
                <div className="col-4">
                    <h1 style={{ fontWeight: '800 !important', fontSize: '50px' }}>{t("HeadofficeMessageTitle")}</h1>
                    <h6 style={{ color: '#716f6f' }}>{t("HeadofficeMessageDetails")}</h6>
                    <div className="img-wrapper" style={{ width: '500px' }}>
                        <img style={{ height: '100%', width: '100%' }} src="img/help.png" alt="" border="0" />
                    </div>
                </div>

            </div>
        </div>
    );
}
